function renderSelect (country, field) {
  return `<div class="ui-form__row ui-form__row_dropdownSelect ${field.rowclass ? field.rowclass + ' ' : ''} ${field.hidden ? 'hidden' : ''} columnfield_">
    ${((field.name === 'province' && country.is_ES)) ? '<div class="" style="margin-bottom: 20px;">tal como aparece en su DNI/NIE</div>' : ''}
    <div class="ui-form__field">
      <div class="ui-dropdown-select ui-dropdown-select_mobile_native">
        <div class="ui-dropdown-field insert-${field.name}"></div>
      </div>
      ${(field.name === 'other_loans_company') ? '<div style="font-size: 12px;font-weight: 300;">' + fields_json.params.for_fields.other_loans_company_hint + '</div>' : ''}
      <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">${field.error}</div>
    </div>
  </div>`
}

export { renderSelect }